"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorldpayServerTransactionAPI = void 0;
const shared_1 = require("@getgreenline/shared");
const WorldpayServerCommonAPI_1 = require("../WorldpayServerCommonAPI");
class WorldpayServerTransactionAPI extends WorldpayServerCommonAPI_1.WorldpayServerCommonAPI {
    constructor(params) {
        super(params.appSpecificHeaders);
        this.submitSaleAsync = async (params) => {
            const { requestId, tenantSpecificHeaders, callbackUrl, payload } = params;
            const headers = {
                ...this.getHeaders(requestId, tenantSpecificHeaders),
                'tp-isasync': true,
            };
            if (callbackUrl)
                headers['tp-callback-url'] = callbackUrl;
            try {
                const asyncRes = await shared_1.axios.post(`${this.apiUrl}/sale`, payload, {
                    headers,
                });
                const res = {
                    operationRetry: asyncRes.headers['operation-retry'],
                    resourceLocation: asyncRes.headers['resource-location'],
                };
                return res;
            }
            catch (error) {
                this.throwError(error);
            }
        };
        this.submitRefundAsync = async (params) => {
            const { requestId, tenantSpecificHeaders, callbackUrl, payload } = params;
            const headers = {
                ...this.getHeaders(requestId, tenantSpecificHeaders),
                'tp-isasync': true,
            };
            if (callbackUrl)
                headers['tp-callback-url'] = callbackUrl;
            try {
                const asyncRes = await shared_1.axios.post(`${this.apiUrl}/refund`, payload, { headers });
                const res = {
                    operationRetry: asyncRes.headers['operation-retry'],
                    resourceLocation: asyncRes.headers['resource-location'],
                };
                return res;
            }
            catch (error) {
                this.throwError(error);
            }
        };
        this.getTransactionFromResourceLocation = async ({ requestId, tenantSpecificHeaders, resourceLocation, }) => {
            try {
                const res = await this.getResourceFromLocation({
                    requestId,
                    tenantSpecificHeaders,
                    resourceLocation,
                });
                return res;
            }
            catch (error) {
                this.throwError(error);
            }
        };
        this.getHeaders = (requestId, tenantSpecificHeaders) => {
            return {
                ...this.getCommonHeaders(requestId, tenantSpecificHeaders),
                'tp-authorization': '2.0',
            };
        };
        this.apiUrl = `${params.baseUrl}/v1`;
    }
}
exports.WorldpayServerTransactionAPI = WorldpayServerTransactionAPI;
//# sourceMappingURL=WorldpayServerTransactionAPI.js.map